import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { shareReplay, Subject } from 'rxjs';

@Component({
  selector: 'app-keyboard',
  templateUrl: './keyboard.component.html',
  styleUrls: ['./keyboard.component.scss']
})
export class KeyboardComponent implements OnInit, OnDestroy {

  public KEYS: any = {
    AT_SIGN: '&#64;',
    NUM_SIGN: '&#35;',
    DOLLAR_SIGN: '&#36;',
    AMPERSAND: '&#38;',
    UNDERSCORE: '&#95;',
    MINUS: '&#45;',
    OPEN_PAREN: '&#40;',
    CLOSE_PAREN: '&#41;',
    EQUAL: '&#61;',
    COLON: '&#58;',
    FORWARD_SLASH: '&#47;',
    EXCLAMATION: '&#33;',
    QUESTION_MARK: '&#63;',
    PLUS: '&#43;',
    PERCENT: '&#37;',
    QUOTE: '&#34;',
    ASTERISK: '&#42;',
    APOSTROPHE: '&#39;',
    BACKSLASH: '&#92;',
    OPEN_CURLY: '&#123;',
    CLOSE_CURLY: '&#125;',
    NOT: '&#172;',
    BROKEN_VERTICAL_BAR: '&#166;',
    VERTICAL_BAR: '&#124;',
    GRAVE_ACCENT: '&#96;',
    SEMICOLON: '&#59;',
    SECTION: '&#167;',
    PARAGRAPH: '&#182;',
    ORDINAL_INDICATOR_M: '&#186;',
    INVERTED_EXCLAMATION: '&#161;',
    INVERTED_QUESTION: '&#191;',
    COMMA: '&#44;',
    PERIOD: '&#46;',
    CARET: '&#94;',
    LESS_THAN: '&#60;',
    GREATER_THAN: '&#62;',
    OPEN_SQUARE: '&#91;',
    CLOSE_SQUARE: '&#93;',
    EURO: '&#8364;',
    POUND: '&#163;',
    CENT: '&#162;',
    YEN: '&#165;',
    TAB: '&#8594;',
    COPYRIGHT: '&#169;',
    REGISTERED_TM: '&#174;',
    TRADEMARK: '&#8482;',
    TILDE: '&#126;',
    DIVIDE: '&#247;',
    TIMES: '&#215;',
    SHIFT: 'SHIFT',
    DELETE: 'DELETE',
    ENTER: 'ENTER',
    SPACE: ' ',
    ALPHA: 'ABC',
    NUMERIC: '123',
    SYMBOL: '{&=',
  }
  public keyboard: { open: boolean, alpha: boolean, numeric: boolean, uppercase: boolean, symbol: boolean, numrow: boolean, keepopen: boolean } = {
    open: false,
    alpha: true,
    numeric: false,
    uppercase: false,
    symbol: false,
    numrow: false,
    keepopen: false
  }
  private submit = new Subject<any>();
  public onSubmit$ = this.submit.pipe(shareReplay())
  private input = new Subject<any>();
  public onInput$ = this.input.pipe(shareReplay())
  public deleteTimeout: any;
  public deleteInterval: any;
  public upperCaseOnly: boolean = false;

  constructor() {
    this.KEYS.BACKTICK = this.KEYS.GRAVE_ACCENT;
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.close()
  }

  @HostListener('document:contextmenu', ['$event'])
  preventContextMenu(event: any) {
    event.preventDefault()
  }

  @HostListener('body:focusin', ['$event'])
  handleFocus(event: any) {
    if (event.target.localName == 'input') {
      let kb: any = document.querySelector('#sc_keyboard');
      this.keyboard.open = true
      let wrapper = kb.parentElement.parentElement.parentElement;
      let kb_placeholder = document.createElement('div')
      let frameContainers = document.querySelectorAll<HTMLElement>('.frame-container')
      kb_placeholder.style.height = kb.clientHeight + 'px';
      kb_placeholder.style.order = '-1';
      kb_placeholder.style.flexShrink = '0';

      kb_placeholder.setAttribute('id', 'kb_placeholder')
      wrapper.dataset.overflowY = wrapper.style.overflowY;
      wrapper.style.overflowY = 'auto';
      wrapper.appendChild(kb_placeholder)
      frameContainers.forEach(el => {
        el.style.height = (window.innerHeight - kb.clientHeight) + 'px'
      })


      this.upperCaseOnly = typeof event.target.dataset.uppercase != "undefined"
      this.keyboard.uppercase = typeof event.target.dataset.uppercase != "undefined";
      this.keyboard.numrow = typeof event.target.dataset.numrow != "undefined";
      // this.keyboard.keepopen = typeof event.target.dataset.keepopen != "undefined";

      event.target.scrollIntoView({ block: 'center' })
    }
  }

  @HostListener('body:focusout', ['$event'])
  handleBlur(event: any) {
    if (event.target.localName == 'input') {
      this.close()
    }
  }

  close() {
    this.keyboard.open = this.keyboard.keepopen
    let kb: any = document.querySelector('#sc_keyboard');
    let wrapper = kb.parentElement.parentElement.parentElement;
    let frameContainers = document.querySelectorAll<HTMLElement>('.frame-container')

    wrapper.style.overflowY = wrapper.dataset.overflowY;
    wrapper.removeAttribute('data-overflow-y');
    if (wrapper.querySelector('#kb_placeholder')) {
      wrapper.querySelector('#kb_placeholder').remove();
    }
    frameContainers.forEach(el => {
      el.style.height = (window.innerHeight) + 'px'
    })
  }

  triggerDelete(input: HTMLInputElement, i: number, v: string) {
    input.value = [v.slice(0, i - 1), v.slice(i, v.length)].join('')
    input.setSelectionRange(i - 1, i - 1)
    this.input.next(input.value)
    input.dispatchEvent(new Event("change"))
  }

  change() {
    let inputs = this.getInputs()
    let inputIndex = this.getActiveInputIndex()
    let input = inputs[inputIndex]

    this.input.next(inputIndex >= 0 ? input.value : '')
  }

  clearDeleteTimeout(e: any) {
    e.preventDefault()
    if (this.deleteInterval) {
      clearInterval(this.deleteInterval)
    }
    if (this.deleteTimeout) {
      clearTimeout(this.deleteTimeout)
    }
  }

  getInputs() {
    let inputs = Array.from(document.querySelectorAll('input'))
    return inputs;
  }

  getActiveInputIndex() {
    let inputs = this.getInputs();
    let inputIndex: number = inputs.findIndex((element: any) => {
      return element == document.activeElement;
    })
    return inputIndex;
  }

  onClick(e: any, keypressed: string) {
    e.preventDefault()
    let inputs = this.getInputs()
    let inputIndex = this.getActiveInputIndex()
    let input = inputs[inputIndex]
    if (input) {
      let i = Number(input.selectionStart);
      let v = input.value;
      // console.log(input.maxLength, v.length)
      if (input.maxLength > 0 && v.length >= input.maxLength) {
        return
      }

      let key = this.keyboard.uppercase ? keypressed.toUpperCase() : keypressed.toLowerCase()
      // this.clearDeleteTimeout()
      if (keypressed.length == 1) {
        input.value = [v.slice(0, i), key, v.slice(i, v.length)].join('')
        input.setSelectionRange(i + 1, i + 1)
      } else {
        switch (keypressed) {
          case this.KEYS.SHIFT:
            this.keyboard.uppercase = !this.keyboard.uppercase
            break;
          case this.KEYS.DELETE:
            this.triggerDelete(input, i, v)
            break;
          case this.KEYS.NUMERIC:
            this.keyboard.alpha = false;
            this.keyboard.numeric = true;
            this.keyboard.symbol = false;
            break;
          case this.KEYS.ALPHA:
            this.keyboard.alpha = true;
            this.keyboard.numeric = false;
            this.keyboard.symbol = false;
            break;
          case this.KEYS.SYMBOL:
            this.keyboard.alpha = false;
            this.keyboard.numeric = false;
            this.keyboard.symbol = true;
            break;
          case this.KEYS.ENTER:
            if ((inputIndex + 1) < inputs.length) {
              inputs[inputIndex + 1].focus()
            } else {
              let timeout = setTimeout(() => {
                let form = this.findForm(input);
                if (form) {
                  form.dispatchEvent(new Event('submit'))
                }
              }, 0);
              this.submit.next({
                preventDefault: () => {
                  clearTimeout(timeout)
                },
                value: input.value
              })
            }
            break;
          default:
            key = String.fromCharCode(Number(key.replace('&', '').replace('#', '').replace(';', '')))
            input.value = [v.slice(0, i), key, v.slice(i, v.length)].join('')
            input.setSelectionRange(i + key.length, i + key.length)
            break;
        }
      }
      this.input.next(input.value)
      input.dispatchEvent(new Event("change"))
    }
  }

  findForm(input: any): any {
    if (input.parentElement && input.parentElement.tagName.toUpperCase() == "FORM") {
      return input.parentElement;
    } else if (input.parentElement) {
      return this.findForm(input.parentElement)
    } else {
      return null;
    }
  }

  touchStart(e: any) {
    if (e.target.classList.contains('key-delete')) {
      let inputs = Array.from(document.querySelectorAll('input'))
      let inputIndex: number = inputs.findIndex((element: any) => {
        return element == document.activeElement;
      })
      let input = inputs[inputIndex]

      if (input) {
        let i = Number(input.selectionStart);
        this.triggerDelete(input, i, input.value)
        this.deleteTimeout = setTimeout(() => {
          this.deleteInterval = setInterval(() => {
            this.triggerDelete(input, i - 1, input.value)
            i--;
          }, 250)
        }, 1000);
      }
    }
  }
  preventBlur(e: any) {
    e.preventDefault()
  }
}
